import PropTypes from 'prop-types';
import Modal from "../modal";
import Icons from "../../Icons/services/Icons";
import Icon from "../../Icons/services/Icon";

function IconModal({ showI, handleshowI, setIcon }) 
{
  const iconosServicio = Object.keys(Icons).filter(
  (nombreIcono) => nombreIcono !== "default");
//----------------------------------------------------------------------------------------------------------------------
  const handleCancel = async () => 
    {
      handleshowI(false);
    };

  return (
    <>
        <Modal isOpen={showI} onClose={() => handleshowI(false)}  title="Seleccionar icono">
            <div className="flex w-[22rem] flex-col lg:w-[30rem]">
                {/* Cuadrícula de iconos */}
                <div className="grid max-h-[24rem] grid-cols-4 gap-2 overflow-y-auto pr-1 sm:grid-cols-5 lg:grid-cols-6">
                    {iconosServicio.map((nombreIcono) => (
                        <button type="button" key={nombreIcono} onClick={() => { setIcon(nombreIcono); handleshowI(false); }}
                             className="nobutton flex h-9 w-9 items-center justify-center  hover:bg-slate-100 text-slate-400"
                        >
                           <Icon svg={nombreIcono} className="h-7 w-7 fill-current" />
                        </button>
                    ))}
                </div>

                <div className="mt-5 flex justify-end">
                  <button type="button" onClick={handleCancel} className="rounded-md border border-slate-300 px-4 py-2 text-sm text-slate-600 hover:bg-slate-50">
                     Cancelar
                  </button>
                </div>
            </div>
        </Modal>
    </>
  );
}

IconModal.propTypes = {
  showI: PropTypes.bool.isRequired,
  handleshowI: PropTypes.func.isRequired,
  setIcon: PropTypes.func.isRequired,
};

export default IconModal;
